export const MYLIST_ACTION_TYPES = {
  SET_MYLIST_ITEMS: "SET_MYLIST_ITEMS",
};
